import { OUT_OF_STOCK, SIZING_KIT } from '../_consts';
import Selections from '../_steps/enums/SizeStep';
import WizStepId from '../_steps/enums/WizStepId';
import type { UseButtonDisabledProps } from './useButtonDisabled';

export const useRingsButtonDisabled = ({
  currentStep,
  isAccessory,
  isOuraRing4Wizard,
  isLoadingPdpData,
  size,
  sizingSelector,
  stockStatus,
}: Partial<UseButtonDisabledProps>) => {
  return (
    Boolean(isLoadingPdpData) ||
    (currentStep === WizStepId.Size &&
      sizingSelector === Selections.ChooseSize &&
      size?.value === SIZING_KIT) ||
    (stockStatus === OUT_OF_STOCK && !isOuraRing4Wizard && !isAccessory)
  );
};
